import React ,{useContext,useState} from 'react';
//import { EnvironmentContext } from '../index';
import { Env1Context } from '../index';
import axios from 'axios';
import Swal from "sweetalert2";

import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Seo from '../Components/Seo';
import address from "../img/contact-1.png"
import emailimg from "../img/contact-2.png"
import phoneimg from "../img/contact-3.png"
import Frame from "../img/Frame.png"

function Contacts() {
  //const  env = useContext(EnvironmentContext);
  const [email, setEmail] = useState('');
  const [rememberMe, setRememberMe] = useState(true);
  //const [error, setError] = useState('');
  const env1 = useContext(Env1Context);
  const [organizationName, setOrganizationName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [demoModule, setDemoModule] = useState('Sales Enquiry');
  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState({});

  const [emailValid, setEmailValid] = useState(false);
  const [emailCheckState, setEmailCheckState] = useState(''); // '', 'checking', 'valid', 'invalid'
  const [emailCheckMsg, setEmailCheckMsg] = useState('');
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [phoneCheckState, setPhoneCheckState] = useState(''); // '', 'error', 'sent', 'valid'
  const [phoneCheckMsg, setPhoneCheckMsg] = useState('');
  const [sendingOtp, setSendingOtp] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const EMAIL_VERIFY_URL = 'https://crmdev.miti.us/api/v1/email/verify-email';
  const DEMO_REQUEST_URL = 'https://crmdev.miti.us/api/request-demo';
  const SEND_OTP_URL = 'https://x47jfk2507.execute-api.us-east-1.amazonaws.com/prod/send-otp';

  const validateEmail = (email) => {
    // Basic email validation
    const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(email).toLowerCase());
  };

 const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      Swal.fire({
        // icon: "info",
        width: 500,
        text: "Please enter your email id.",
        confirmButtonText: 'OK',
      });
      return; // Make sure to return to prevent further execution
    }

    const payload = {
      Email: email,
      IsReact: 1,
      Isremeberme: rememberMe,
    };

    try {
      const response = await axios.post(`${env1}/index1.php/api/users/registerwithemail`, payload);
      // Handle response
      if (response.data.Entity.isRegistered) {
        Swal.fire({
          // icon: "info",
          width: 500,
          text: "Registered successfully...",
          confirmButtonText: 'OK',
        }).then(() => {
          setEmail(''); // Clear the email field after clicking OK
        });
      } else if (response.data.Entity.isUserAuthenticated) {
        Swal.fire({
          // icon: "info",
          width: 500,
          text: "Entered email already exists, Please try with different email id.",
          confirmButtonText: 'OK',
          confirmButtonColor: "#0e91ef",
        }).then(() => {
          setEmail(''); // Clear the email field after clicking OK
        });
      }
    } catch (error) {
      // Handle error
      Swal.fire({
        // icon: "error",
        width: 500,
        text: "An error occurred. Please try again.",
        confirmButtonText: 'OK',
      });
    }
  };

  const validateEmail1 = (email) => {
    const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(email).toLowerCase());
  };

  const handleEmailAddressChange = (e) => {
    setEmailAddress(e.target.value);
    setErrors((prevErrors) => ({ ...prevErrors, emailAddress: false }));
    setEmailValid(false);
    setEmailCheckState('');
    setEmailCheckMsg('');
  };

  const handleEmailBlur = async () => {
    const value = emailAddress.trim();
    if (!value) return;

    if (!validateEmail1(value)) {
      setEmailValid(false);
      setEmailCheckState('invalid');
      setEmailCheckMsg('Please enter a valid email address.');
      return;
    }

    setEmailValid(false);
    setEmailCheckState('checking');
    setEmailCheckMsg('Verifying…');

    try {
      const { data } = await axios.post(EMAIL_VERIFY_URL, { email: value });
      const result = data && data.data && data.data.results && data.data.results[0];
      if (result && result.is_valid === true) {
        setEmailValid(true);
        setEmailCheckState('valid');
        setEmailCheckMsg('Email is valid');
      } else {
        setEmailCheckState('invalid');
        setEmailCheckMsg('Please enter a valid email address.');
      }
    } catch (error) {
      setEmailCheckState('invalid');
      setEmailCheckMsg('Could not verify email. Please try again.');
    }
  };

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
    setErrors((prevErrors) => ({ ...prevErrors, phone: false }));
    setPhoneVerified(false);
    setPhoneCheckState('');
    setPhoneCheckMsg('');
  };

  const decodeOtpToken = (token) => {
    try {
      return atob(atob(atob(token))).split('').reverse().join('');
    } catch (error) {
      return null;
    }
  };

  const promptOtpVerification = (token, phoneForDisplay) => {
    Swal.fire({
      title: 'Verify mobile number',
      text: `Enter the 4-digit OTP sent to ${phoneForDisplay}`,
      input: 'text',
      inputAttributes: {
        maxlength: 4,
        inputmode: 'numeric',
        autocomplete: 'one-time-code',
        style: 'text-align:center; letter-spacing:0.5em; font-size:1.4rem;',
      },
      confirmButtonText: 'Verify OTP',
      confirmButtonColor: '#0e91ef',
      showDenyButton: true,
      denyButtonText: 'Resend OTP',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      preConfirm: (value) => {
        const entered = String(value || '').trim();
        const decoded = decodeOtpToken(token);
        if (!entered || decoded === null || decoded.trim() !== entered) {
          Swal.showValidationMessage('Incorrect OTP. Please try again.');
          return false;
        }
        return true;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setPhoneVerified(true);
        setPhoneCheckState('valid');
        setPhoneCheckMsg('Mobile number verified');
      } else if (result.isDenied) {
        sendOtp();
      }
    });
  };

  const sendOtp = async () => {
    let normalized = phone.replace(/\D/g, '');
    if (normalized.length === 12 && normalized.startsWith('91')) normalized = normalized.slice(2);
    if (normalized.length < 10) {
      setPhoneCheckState('error');
      setPhoneCheckMsg('Please enter a valid phone number.');
      return;
    }

    setSendingOtp(true);
    setPhoneCheckState('');
    setPhoneCheckMsg('');

    try {
      const { data } = await axios.post(SEND_OTP_URL, { phone_code: '+91', phone: normalized });
      if (data && data.status === true) {
        setPhoneCheckState('sent');
        setPhoneCheckMsg('OTP sent — check your phone.');
        promptOtpVerification(data.token, phone);
      } else {
        setPhoneCheckState('error');
        setPhoneCheckMsg('Failed to send OTP. Please try again.');
      }
    } catch (error) {
      setPhoneCheckState('error');
      setPhoneCheckMsg('Could not send OTP. Please try again.');
    } finally {
      setSendingOtp(false);
    }
  };

  const handleSubmitMessage = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!firstName) newErrors.firstName = true;
    if (!lastName) newErrors.lastName = true;
    if (!emailAddress) newErrors.emailAddress = true;
    else if (!validateEmail1(emailAddress)) newErrors.emailAddress = true;
    if (!phone) newErrors.phone = true;

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (!emailValid) {
      Swal.fire({
        width: 500,
        text: "Please verify your email address before submitting.",
        confirmButtonText: 'OK',
      });
      return;
    }

    if (!phoneVerified) {
      Swal.fire({
        width: 500,
        text: "Please verify your mobile number with the OTP before submitting.",
        confirmButtonText: 'OK',
      });
      return;
    }

    const now = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    const requestDatetime = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

    const payload = {
      source: 'signulu',
      request_datetime: requestDatetime,
      name: `${firstName} ${lastName}`.trim(),
      email: emailAddress.trim(),
      company: organizationName.trim(),
      phone: phone.trim(),
      business: demoModule,
      number_of_licenses: 0,
      description: message.trim(),
    };

    setSubmitting(true);
    try {
      const { data } = await axios.post(DEMO_REQUEST_URL, payload);
      if (data && data.success) {
        Swal.fire({
          width: 500,
          text: "Thank you for reaching out to us. A representative will review your request and get back to you shortly.",
          confirmButtonText: 'OK',
          confirmButtonColor: "#0e91ef",
        }).then(() => {
          setOrganizationName('');
          setFirstName('');
          setLastName('');
          setEmailAddress('');
          setPhone('');
          setDemoModule('Sales Enquiry');
          setMessage('');
          setErrors({});
          setEmailValid(false);
          setEmailCheckState('');
          setEmailCheckMsg('');
          setPhoneVerified(false);
          setPhoneCheckState('');
          setPhoneCheckMsg('');
        });
      } else {
        Swal.fire({
          width: 500,
          text: (data && data.message) || "Submission failed. Please try again.",
          confirmButtonText: 'OK',
        });
      }
    } catch (error) {
      Swal.fire({
        width: 500,
        text: "An error occurred. Please try again.",
        confirmButtonText: 'OK',
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleInputChange = (setter, field) => (e) => {
    setter(e.target.value);
    setErrors((prevErrors) => ({ ...prevErrors, [field]: false }));
  };

  return (
    <div>
      <Seo
        title="Contact Signulu | Sales & Support"
        description="Contact the Signulu team by phone, email or the form below for sales, support and partnership enquiries."
        canonical="https://www.signuluone.com/contact.html"
      />
      <Header />
      <section className="pricing_box">
        <div className="container container-lg container-xl container-xxl">
          <div className="row">
            <div className="col-12">
              <div className="heading" data-aos="fade-up" data-aos-duration="1500">
                <h2>Signulu <span>Contact</span></h2>
                <p>You can contact us using any of the below modes, and we will be happy to assist you or answer your queries.</p>
              </div>
            </div>
          </div>
          <div className="row contact_detais" data-aos="fade-up" data-aos-duration="1500">
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <div className="contact_div d-flex">
                <div className="images">
                  <img src={address} alt="Contact 1" />
                </div>
                <div className="text">
                  <h4>Address:</h4>
                  <p>101 Morgan Lane, Suite #188 Plainsboro, NJ 08536-3315, USA.</p>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 borders">
              <div className="contact_div d-flex">
                <div className="images">
                  <img src={emailimg} alt="Contact 2" />
                </div>
                <div className="text">
                  <h4>Email Us:</h4>
                  <a href="mailto:info@signulu.com">info@signulu.com,</a><br />
                  <a href="mailto:support@signulu.com">support@signulu.com</a>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 padding_left">
              <div className="contact_div d-flex">
                <div className="images">
                  <img src={phoneimg} alt="Contact 3" />
                </div>
                <div className="text">
                  <h4>Phone Number:</h4>
                  <a href="tel:+1-6098530237">+1-6098530237</a><br />
                  <a href="tel:+91 9176 446858">+91 9176 446858</a>
                </div>
              </div>
            </div>
          </div>
          <div className="row contact_input">
      <div className="headline" data-aos="fade-up" data-aos-duration="1500">
        <h2>Have a <span>Question?</span></h2>
        <p>Please enter your information below <span>and a Signulu associate will</span> contact you.</p>
      </div>
    {/* //   <form className="row input_div" data-aos="fade-up" data-aos-duration="1500" onSubmit={handleSubmitMessage}>
    //   <div className="col-xl-4 col-md-6 col-sm-12 padd_battom">
    //     <input 
    //       type="text"
    //       placeholder="Name of Organization"
    //       value={organizationName}
    //       onChange={handleInputChange(setOrganizationName, 'organizationName')}
    //     />
    //   </div>
    //   <div className="col-xl-4 col-md-6 col-sm-12 padd_battom">
    //     <input
    //       type="text"
    //       placeholder="First Name"
    //       value={firstName}
    //       onChange={handleInputChange(setFirstName, 'firstName')}
    //       className={errors.firstName ? 'error' : ''}
    //     />
    //   </div>
    //   <div className="col-xl-4 col-md-6 col-sm-12 padd_battom">
    //     <input
    //       type="text"
    //       placeholder="Last Name"
    //       value={lastName}
    //       onChange={handleInputChange(setLastName, 'lastName')}
    //       className={errors.lastName ? 'error' : ''}
    //     />
    //   </div>
    //   <div className="col-xl-4 col-md-6 col-sm-12 padd_battom">
    //     <input
    //       type="text"
    //       placeholder="Email Address"
    //       value={emailAddress}
    //       onChange={handleEmailAddressChange}
    //       onBlur={handleEmailBlur}
    //       className={errors.emailAddress ? 'error' : ''}
    //     />
    //     {emailCheckMsg && (
    //       <span className={`field-feedback ${emailCheckState === 'valid' ? 'valid' : emailCheckState === 'invalid' ? 'invalid' : 'info'}`}>
    //         {emailCheckMsg}
    //       </span>
    //     )}
    //   </div>
    //   <div className="col-xl-4 col-md-6 col-sm-12 padd_battom">
    //     <div className="phone-input-group">
    //       <input
    //         type="text"
    //         placeholder="Phone"
    //         value={phone}
    //         onChange={handlePhoneChange}
    //         className={errors.phone ? 'error' : ''}
    //       />
    //       <button
    //         type="button"
    //         className="otp-btn"
    //         onClick={sendOtp}
    //         disabled={sendingOtp || phoneVerified}
    //       >
    //         {phoneVerified ? '✓ Verified' : sendingOtp ? 'Sending…' : 'Send OTP'}
    //       </button>
    //     </div>
    //     {phoneCheckMsg && (
    //       <span className={`field-feedback ${phoneCheckState === 'valid' ? 'valid' : phoneCheckState === 'error' ? 'invalid' : 'info'}`}>
    //         {phoneCheckMsg}
    //       </span>
    //     )}
    //   </div>
    //   <div className="col-xl-4 col-md-6 col-sm-12 padd_battom">
    //     <select value={demoModule} onChange={(e) => setDemoModule(e.target.value)}>
    //       <option value="Sales Enquiry">Sales Enquiry</option>
    //       <option value="Support">Support</option>
    //       <option value="Partnerships">Partnerships</option>
    //       <option value="Others">Others</option>
    //     </select>
    //   </div>
    //   <div className="col-12">
    //     <textarea
    //       placeholder="Enter your message"
    //       value={message}
    //       onChange={handleInputChange(setMessage, 'message')}
    //     ></textarea>
    //   </div>
    //   <div className="col-12 btn_padd">
    //     <button type="submit" disabled={!emailValid || !phoneVerified || submitting}>
    //       {submitting ? 'SENDING…' : 'SEND MESSAGE'}
    //     </button>
    //   </div>
    //   <div className="col-12 paragraphy">
    //     <p>Or feel free to contact us at our Helpline: <span>+1-6098530237 &amp; +91 9176 446858</span> for more information.</p>
    //   </div>
    // </form>
    */}
    
  <div className="row input_div" data-aos="fade-up" data-aos-duration="1500">
  {/* Book a Demo */}
  <div className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-center">
    <iframe
      src="https://mi-agentic-crm-frontend-master-4384650420.us-central1.run.app/book?key=pk_e791b7807b2868fb"
      width="100%"
      height="850"
      style={{
        border: "none",
        width: "100%",
        height: "850px",
      }}
      title="Book a Demo"
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads"
    ></iframe>
  </div>

  {/* Submit a Support Ticket */}
  <div className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-center">
    <iframe
      src="https://mi-agentic-crm-frontend-master-4384650420.us-central1.run.app/widget?key=pk_e791b7807b2868fb&mode=form"
      width="100%"
      height="850"
      style={{
        border: "none",
        width: "100%",
        height: "850px",
      }}
      title="Submit a Support Ticket"
      loading="lazy"
      referrerPolicy="strict-origin-when-cross-origin"
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads"
    ></iframe>
  </div>
</div>

    </div>
        </div>
      </section>
      <section className="contact_map" data-aos="fade-up" data-aos-duration="1500">
        <div className="container-fluid">
          <div className="row">
            <div className="contact_map_div">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3041.5176009771158!2d-74.58543110000001!3d40.3308625!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3ddfa4674964d%3A0x8ea3dfe4a888216!2s101%20Morgan%20Ln%2C%20Plainsboro%20Township%2C%20NJ%2008536%2C%20USA!5e0!3m2!1sen!2sin!4v1687524138103!5m2!1sen!2sin"
                width="800"
                height="600"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Map"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
      <section className="trial-box mar-contact" data-aos="fade-up" data-aos-duration="2500">
        <div className="container container-lg container-xl container-xxl">
          <div className="row background align-items-center justify-content-between m-0 trySignulu-inp-box">
            <div className="col-xl-6 col-md-12 text-mail">
              <h3>Get up to 5 documents signed for free, every month</h3>
              <p>Try Signulu eSignature for 14 days. No credit card required.</p>
              <form onSubmit={handleSubmit}>
                <div className="your-email-id-box">
                  <input
                    type="email"
                    placeholder="Your email id"
                    className="email-inp-field"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button type="submit" className="start-free-trail-with-email">
                    Start Trial
                  </button>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    style={{ width: '20px', height: '20px', backgroundColor: '#FFFFFF', border: 'blue' }}
                    id="rememberme"
                    type="checkbox"
                    checked={rememberMe}
                    onChange={() => setRememberMe(!rememberMe)}
                  />
                  <p className="subscrib">Subscribe to our Newsletters</p>
                </div>
                <p className="no-card">*No credit card required</p>
              </form>
            </div>
            <div className="col-xl-6 col-md-12 btn-part img-frame">
              <img src={Frame} className="frame-img" alt="Frame" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Contacts;
